import React from "react";

import { BlackTextButton } from "../black-text-button/black-text-button.styles";
import { connect } from "react-redux";
import { showAlertAction } from "../../redux/alert/alert.actions";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const ForgotPasswordButton = ({ showAlert }) => {
	const forgotPasswordClicked = () => {
		showAlert({
			title: "Reset password",
			description: "Where should we send the password reset email?",
			buttons: [
				{
					title: "cancel",
					styles: "background-color:gray;margin-right:5px;",
				},
				{
					title: "Send",
					onClick: email => {
						const auth = getAuth();
						sendPasswordResetEmail(auth, email)
							.then(() => {
								showAlert({
									title: "Success",
									description:
										"Please check your email and click the Reset Password link to continue.",
								});
							})
							.catch(error => {
								showAlert({
									title: "Oops.",
									description: error.message,
									buttons: [
										{
											title: "cancel",
											styles: "background-color:gray;margin-right:5px;",
										},
										{
											title: "retry",
											onClick: () => {
												forgotPasswordClicked();
											},
										},
									],
								});
							});
					},
					getInputByID: "email",
				},
			],
			inputs: [{ id: "email" }],
		});
	};
	return (
		<BlackTextButton onClick={forgotPasswordClicked}>
			forgot password?
		</BlackTextButton>
	);
};

const mapDispatchToProps = dispatch => ({
	showAlert: alert => dispatch(showAlertAction(alert)),
});

export default connect(null, mapDispatchToProps)(ForgotPasswordButton);
